import localePt from "@angular/common/locales/pt";
import { enableProdMode, importProvidersFrom, LOCALE_ID } from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AppComponent } from "./app/app.component";
import { bootstrapApplication } from "@angular/platform-browser";
import { environment } from "./environments/environment";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, RouteReuseStrategy } from "@angular/router";
import { register } from "swiper/element/bundle";
import { registerLocaleData } from "@angular/common";
import { routes } from "./app/app.routes";
import { Storage } from "@ionic/storage";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import { installChunkRecovery } from "./app/core/boot/chunk-recovery";

registerLocaleData(localePt);

register();

if (environment === "production") {
  enableProdMode();
}

if (typeof window !== "undefined") {
  console.info("[Startup] main.ts — bundle carregado");
  // Antes dos listeners de log: um chunk lazy órfão (aba aberta durante um deploy)
  // precisa virar reload, não erro logado.
  installChunkRecovery();
  window.addEventListener("error", (event) => {
    console.error("[Startup] Erro global não tratado:", event.error ?? event.message);
  });
  window.addEventListener("unhandledrejection", (event) => {
    console.error("[Startup] Promise rejeitada não tratada:", event.reason);
  });
}


export { endpointBase, endpointBaseGRPC, applicationClientId } from "./app/config/api.config";

export const encryptKey =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCRAt4G3LCUiWtOAFBm8rhyoyWC1p3O5HMraqC98MyvEXO+D7pe9L+9sZRw6ARMz7kXGvVavTjxK/GYKmnVmJfMI28m/CQVWrhh9JOSytySEN107dd1nnLbYAJEsYdjD2R6RuFz5U6pHckvnaxonJ1N/iVuXSFTNhBG2H5uT9ezmwIDAQAB";


bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom(IonicModule.forRoot({ mode: "md" })),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
    Storage,
    provideAnimations(),
  ],
})
  .then(() => console.info("[Startup] Angular bootstrap OK"))
  .catch((error) => {
    console.error("[Startup] Falha fatal no bootstrap Angular:", error);
  });
